import { FunctionComponent, useMemo } from 'react'

import styled, { css } from 'styled-components'

import { Image } from '@utils/cook/types'
import FreeRatioImage from '@components/FreeRatioImage'

export interface ImageProps {
  image: Image<'free'>
  className?: string
}

const StyledFirstName = styled.div`
  ${({
    theme: {
      typography: {
        subheads: {
          xsmall2: { bundledCSS: xsmall2SubheadCSS },
        },
      },
      colors: { textDefault },
      utils: { ellipsis },
    },
  }) => css`
    ${xsmall2SubheadCSS};
    color: ${textDefault};
    ${ellipsis('100%', 1)};
  `}
`

const StyledLastName = styled.div`
  ${({
    theme: {
      typography: {
        subheads: {
          small1: { bundledCSS: small1SubheadCSS },
        },
      },
      colors: { textDefault },
      utils: { ellipsis },
    },
  }) => css`
    ${small1SubheadCSS};
    color: ${textDefault};
    ${ellipsis('100%', 1)};
  `}
`
const SportCardImage: FunctionComponent<ImageProps> = ({
  className,
  image,
}) => {
  const constraints = useMemo(() => {
    const constraint = { width: 48, height: 56 }

    return {
      desktop: constraint,
      tablet: constraint,
      mobile: constraint,
      mobileSmall: constraint,
    }
  }, [])

  return image ? (
    <FreeRatioImage
      className={className}
      src={image.src}
      alt={image.alt}
      crops={image.crops ?? {}}
      originalDimensions={{
        width: image.width,
        height: image.height,
      }}
      constraints={constraints}
    />
  ) : null
}

export { StyledFirstName, StyledLastName, SportCardImage }
